var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.row[_vm.column.key])+"%")]),(_vm.row['colonel_type'] === '1' && _vm.column['showPay'])?_c('span',{staticClass:"text"},[_vm._v(_vm._s('(支出' + _vm.row['disburse_commission_rate'] + '%)'))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }